import { render } from "./adminList.vue?vue&type=template&id=64b61e3a&scoped=true"
import script from "./adminList.vue?vue&type=script&lang=js"
export * from "./adminList.vue?vue&type=script&lang=js"

import "./adminList.vue?vue&type=style&index=0&id=64b61e3a&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b61e3a"]])

export default __exports__